import { Injectable } from '@angular/core';
import { interval } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class SessionService {
    private jwtHelper = new JwtHelperService();

    constructor(private authService: AuthService) {
        interval(60000).subscribe(() => this.checkToken());
    }

    private checkToken(): void {
        const token = this.authService.getToken();
        if (token && this.jwtHelper.isTokenExpired(token)) {
            this.authService.refreshAccessToken().subscribe({
                error: () => this.authService.logout()
            });
        }
    }
}
